// import React, { useState, useEffect } from 'react'
// import { Modal, Box, TextField, Button, Snackbar, Alert } from '@material-ui/core'
// import axios from 'axios'
// import iziToast from 'izitoast'
// import getToken from 'utils/getToken'

// interface EditModalProps {
// 	open: boolean
// 	setOpen: (open: boolean) => void
// 	rowData: any
// 	onSuccess?: () => void
// }

// const SectionsEdit: React.FC<EditModalProps> = ({ open, setOpen, rowData, onSuccess }) => {
// 	const [name, setName] = useState('')
// 	const [description, setDescription] = useState('')

// 	const [loading, setLoading] = useState(false)
// 	const [error, setError] = useState('')
// 	const token = getToken()
// 	useEffect(() => {
// 		if (rowData) {
// 			setName(rowData.name || '')
// 			setDescription(rowData.description || '')
// 		}
// 	}, [rowData])

// 	const handleSave = async () => {
// 		setLoading(true)
// 		setError('')

// 		try {
// 			const response = await axios.put(
// 				`${process.env.REACT_APP_API_URL}/api/v1/custom/updateSection`,
// 				{
// 					name: name.trim(),
// 					description: description.trim(),
// 					sectionId: rowData._id,
// 					userId: rowData.createdBy,
// 					modifiedBy: rowData.createdBy
// 				},
// 				{
// 					headers: {
// 						Authorization: `JWT ${token}`
// 					}
// 				}
// 			)

// 			if (response.status === 200) {
// 				setOpen(false)
// 				iziToast.success({
// 					message: response.data.message || 'Section created successfully!'
// 				})
// 				onSuccess?.()
// 			} else {
// 				iziToast.error({
// 					message: 'Failed to create section. No message in response.'
// 				})
// 				console.error('Unexpected response:', response.data)
// 			}
// 		} catch (error) {
// 			console.error('Error updating section:', error)
// 			setError(
// 				axios.isAxiosError(error)
// 					? error.response?.data?.message || 'Failed to update section'
// 					: 'An unknown error occurred'
// 			)
// 		} finally {
// 			setLoading(false)
// 		}
// 	}

// 	return (
// 		<>
// 			<Modal open={open} onClose={() => !loading && setOpen(false)}>
// 				<Box
// 					sx={{
// 						position: 'absolute',
// 						top: '50%',
// 						left: '50%',
// 						transform: 'translate(-50%, -50%)',
// 						width: 400,
// 						bgcolor: 'background.paper',
// 						p: 3,
// 						boxShadow: 24,
// 						borderRadius: 2
// 					}}
// 				>
// 					<h2>Edit Section</h2>
// 					<TextField
// 						label="Section Name"
// 						fullWidth
// 						margin="normal"
// 						value={name}
// 						onChange={e => {
// 							setName(e.target.value)
// 							setError('')
// 						}}
// 						error={!!error}
// 						helperText={error}
// 						required
// 					/>
// 					<TextField
// 						label="Description"
// 						fullWidth
// 						margin="normal"
// 						value={description}
// 						onChange={e => setDescription(e.target.value)}
// 						multiline
// 						rows={3}
// 					/>
// 					<Box display="flex" justifyContent="flex-end" gap={1} mt={2}>
// 						<Button variant="outlined" onClick={() => setOpen(false)}>
// 							Cancel
// 						</Button>
// 						<Button
// 							variant="contained"
// 							color="primary"
// 							onClick={handleSave}
// 							disabled={loading || !name.trim()}
// 						>
// 							{loading ? 'Updating...' : 'Update'}
// 						</Button>
// 					</Box>
// 				</Box>
// 			</Modal>
// 		</>
// 	)
// }

// export default SectionsEdit

import React, { useState, useEffect } from 'react'
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	TextField,
	Button,
	Box,
	IconButton
} from '@material-ui/core'
import axios from 'axios'
import iziToast from 'izitoast'
import { useStoreon } from 'storeon/react'
import { Close } from '@material-ui/icons'

interface EditModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	rowData: any
	onSuccess?: () => void
}

const SectionsEdit: React.FC<EditModalProps> = ({ open, setOpen, rowData, onSuccess }) => {
	const [name, setName] = useState('')
	const [description, setDescription] = useState('')
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState('')
	const { token } = useStoreon('token')
	const handleClose = () => setOpen(false)
	// const handleCancel = () => {
	// 	setName('')
	// 	setDescription('')
	// }
	useEffect(() => {
		if (rowData) {
			setName(rowData.name || '')
			setDescription(rowData.description || '')
		}
	}, [rowData])

	const handleSave = async () => {
		setLoading(true)
		setError('')

		try {
			const response = await axios.put(
				`${process.env.REACT_APP_API_URL}/api/v1/custom/updateSection`,
				{
					name: name.trim(),
					description: description.trim(),
					sectionId: rowData._id,
					userId: rowData.createdBy,
					modifiedBy: rowData.createdBy
				},
				{
					headers: {
						Authorization: ` ${token}`
					}
				}
			)

			if (response.status === 200) {
				setOpen(false)
				iziToast.success({
					message: response.data.message || 'Section updated successfully!'
				})
				onSuccess?.()
			} else {
				iziToast.error({ message: 'Failed to update section.' })
				console.error('Unexpected response:', response.data)
			}
		} catch (error) {
			console.error('Error updating section:', error)
			setError(
				axios.isAxiosError(error)
					? error.response?.data?.message || 'Failed to update section'
					: 'An unknown error occurred'
			)
		} finally {
			setLoading(false)
		}
	}

	return (
		<Dialog open={open} onClose={() => !loading && setOpen(false)} fullWidth maxWidth="sm">
			<DialogTitle
				disableTypography
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					backgroundColor: 'rgb(125, 110, 241)',
					height: '50px',
					color: 'white',
					padding: '0 16px'
				}}
			>
				<h2 style={{ margin: 0, fontSize: '1.25rem' }}>Edit Section</h2>
				{/* <IconButton onClick={handleClose} style={{ marginRight: '-18px' }}> */}
				<Close style={{ color: 'white', cursor: 'pointer' }} onClick={handleClose} />
				{/* </IconButton> */}
			</DialogTitle>
			<DialogContent>
				<TextField
					label="Section Name"
					fullWidth
					margin="normal"
					value={name}
					onChange={e => {
						setName(e.target.value)
						setError('')
					}}
					error={!!error}
					helperText={error}
					required
				/>
				<TextField
					label="Description"
					fullWidth
					margin="normal"
					value={description}
					onChange={e => setDescription(e.target.value)}
					multiline
					rows={3}
				/>
			</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={() => setOpen(false)}>
					Cancel
				</Button>
				<Button
					variant="contained"
					color="primary"
					onClick={handleSave}
					disabled={loading || !name.trim()}
				>
					{loading ? 'Updating...' : 'Update'}
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default SectionsEdit
